import { Widget, Form, ModalLayoutCenter } from "@kanda-libs/ks-component-ts";
import { Button, Loader } from "@kanda-libs/ks-design-library";
import type { FunctionComponent, MutableRefObject } from "react";
import { VALIDATION } from "../constants";

import useVerifyCompanyForm from "../useVerifyCompanyForm";

export interface CompanyVerifyModalFormProps {
  handleClose: () => void;
  ref?: MutableRefObject<HTMLElement | undefined>;
}

const CompanyVerifyModalForm: FunctionComponent<CompanyVerifyModalFormProps> =
  function ({ handleClose, ref }) {
    const { form, isSubmitting, onSubmit } = useVerifyCompanyForm(handleClose);

    return (
      <>
        <ModalLayoutCenter
          id="staff-company-verify"
          onClose={handleClose}
          ref={ref as MutableRefObject<HTMLDivElement>}
          className="w-10/12 p-4 md:w-160"
        >
          <Form
            id="staff-company-verify"
            form={form}
            onSubmit={onSubmit}
            className="flex flex-col w-full"
          >
            <p className="mb-4 text-20-24-em">Verify company</p>
            <p className="mb-6">Please provide the company's FCA number:</p>
            <Widget.CompanyFcaNumber validation={VALIDATION} />
            <Button.Text
              id="staff-company-verify"
              submit
              disabled={isSubmitting}
              label="Submit"
              className="mx-auto"
            />
          </Form>
        </ModalLayoutCenter>
        <Loader isLoading={isSubmitting} />
      </>
    );
  };

export default CompanyVerifyModalForm;
